import React from 'react';
import { Empty } from 'antd';

const NoData: React.FC = () => <Empty />;

export default NoData;